import LayoutIndex from '../layout/LayoutIndex'

const home = {
  path: '/index',
  component: LayoutIndex,
  redirect: '/index',
  name: 'index',
  children: [
    {
      path: '/index',
      name: 'index',
      component: () => import(/* webpackChunkName: "index" */ '../views/index/index.vue')
    }
  ]
}
export default home
